export const DIALOG_TITLE_ID = 'alert-dialog-title';
export const DIALOG_DESCRIPTION_ID = 'alert-dialog-description';
